const PREFILL_KEY = "portal_signup_prefill";

type SignupPrefill = {
	email?: string;
	connectPermitPublicIdentifier?: string;
};

export const writeSignupPrefill = (prefill: SignupPrefill) => {
	try {
		sessionStorage.setItem(PREFILL_KEY, JSON.stringify(prefill));
	} catch {
		// Storage unavailable - parker just types their email again
	}
};

export const readSignupPrefill = (): SignupPrefill => {
	try {
		const raw = sessionStorage.getItem(PREFILL_KEY);
		return raw ? (JSON.parse(raw) as SignupPrefill) : {};
	} catch {
		return {};
	}
};

export const clearSignupPrefill = () => {
	try {
		sessionStorage.removeItem(PREFILL_KEY);
	} catch {
		// Nothing to clear
	}
};
